import { qportalApi } from './qportal-api';
export const BusinessDecisionLogApi = {
    get: async (filter, signal) => (await qportalApi.get('admin/business-decision-log', { params: filter, signal })).data
};
